const e = "Und", n = "Zurück", i = "Schließen", r = "Weitermachen", t = "Tage", s = "d", o = "E-Mail", a = "Hallo", l = "Stunde", d = "Stunden", u = "h", c = "Minuten", h = "min", g = "keiner", X = "Optional", b = "Personen", m = "Person", f = "Registrieren", k = "Sekunden", y = "s", p = "Senden", S = "Wenn Sie auf diesen Link klicken, akzeptieren Sie unsere Pläne Ihnen Werbungen von unserer Marke zu kommerziellen Zwecken zu schicken. In Übereinstimmung mit der Datenschutz-Grundverordnung (DSGVO) informieren wir Sie darüber, dass Ihre Daten in unsere Datenbanken aufgenommen werden. Als Kunde können Sie die unter unserer Kontrolle befindlichen personenbezogenen Daten frei kennen und darauf zugreifen und Ihre Rechte als Eigentümer dieser Daten gemäß der Datenschutz-Grundverordnung (DSGVO) ausüben.", w = "Ich akzeptiere die Bedingungen und Konditionen", z = {
  "(Optional)": "(Optional)",
  "Already registered?": "Sind Sie registriert?",
  and: e,
  "Apply promocode": "Promocode anwenden",
  Back: n,
  "Book Now": "Jetzt buchen",
  "Call Now": "Jetzt anrufen",
  "Click here": "Klicken Sie hier",
  Close: i,
  "Close dialog": "Dialog schließen",
  "Confirm your email": "Bestätigen Sie Ihre E-Mail",
  "Contact Now": "Jetzt kontaktieren",
  Continue: r,
  days: t,
  days_abbr: s,
  Email: o,
  "Enter the validation code sent to your email": "Geben Sie den an Ihre E-Mail gesendeten Validierungscode ein",
  "Exclusive benefits unlocked!": "Exklusive Vorteile werden freigeschaltet!",
  "Expand notification": "Meldung erweitern",
  "Great! Email successfully sent!": "Großartig! E-Mail erfolgreich gesendet!",
  Hello: a,
  hour: l,
  hours: d,
  hours_abbr: u,
  "I agree to the": "Ich bin einverstanden mit der",
  "Invalid code": "Ungültiger Code",
  "Last reservation was XXXXXX hours ago": "Zuletzt gebucht vor XXXXXX Stunden",
  "Loyalty Login": "Loyalty Login",
  "Loyalty Login's default Terms & Conditions": "Standard-Geschäftsbedingungen für den Loyalty Login",
  "Main content": "Hauptinhalt",
  minutes: c,
  minutes_abbr: h,
  none: g,
  "Not registered yet?": "Noch nicht registriert?",
  "Not registered?": "Nicht registriert?",
  "Only for registered users": "Nur für registrierte Benutzer",
  "Only for specific rates": "Nur zu bestimmten Raten",
  Optional: X,
  people: b,
  "Perk 1 will be listed here": "Perk 1 wird hier aufgelistet",
  "Perk 2 will be listed here": "Perk 2 wird hier aufgelistet",
  "Perk 3 will be listed here": "Perk 3 wird hier aufgelistet",
  person: m,
  "Picture icon": "Bild-Symbol",
  "Please, provide a valid e-mail": "Bitte geben Sie eine gültige E-Mail an",
  "Privacy policy": "Datenschutzerklärung",
  Register: f,
  "Resend code": "Code erneut senden",
  seconds: k,
  seconds_abbr: y,
  "Send to booking engine": "An die Buchungsmaschine senden",
  Sending: p,
  "Sending search": "E-Mail wird verschickt",
  "Sign in": "Anmelden",
  "Sign in to your account": "Bei Ihrem Konto anmelden",
  "Something went wrong. Please, try again later.": "Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal.",
  "Subject to availability": "Bei Verfügbarkeit",
  "Terms and conditions": "Allgemeine Geschäftsbedingungen",
  Terms_default: S,
  Terms_default_label: w,
  "Thank you!": "Vielen Dank!",
  "There are XXXXXX people looking at this hotel right now": "XXXXXX Personen sehen sich gerade dieses Hotel an",
  "There has been an error.": "Es gab einen Fehler.",
  "This conversation will be recorded for quality and training purposes.": "Dieses Gespräch wird zu Qualitäts- und Schulungszwecken aufgezeichnet.",
  "This is a standard paragraph, use it to display information.": "Dies ist ein Standardabsatz, der zur Anzeige von Informationen verwendet wird.",
  'This is paragraph. <b>Bold</b> it, <i>italicise</i> it, <u>underline</u> it, add <a href="#">links</a>, emojis 🙂, and more!': 'Das ist ein Absatz. <b>Fett</b>, <i>Kursiv</i>, <u>Unterstreichen</u>, <a href="#">Links</a>, Emojis 🙂, und mehr!',
  "Title of your message": "Titel Ihrer Nachricht",
  "Today's special offer: XXXXXX": "Angebot des Tages: XXXXXX",
  "View all XXXXXX perks": "Alle XXXXXX Vergünstigungen anzeigen",
  "We have received your form submission correctly": "Formular erfolgreich versendet.",
  "We will send you an email with your search very soon.": "Wir senden Ihnen in Kürze eine E-Mail mit Ihrer Suche",
  "Web exclusive": "Online-Vorteil",
  "XXXXXX people have already booked today": "XXXXXX Personen haben heute bereits gebucht",
  "XXXXXX people have looked at this hotel today": "XXXXXX Personen haben sich dieses Hotel heute angesehen",
  "XXXXXX% discount only today": "Nur heute: XXXXXX% Rabatt",
  "You must agree to the Terms & Conditions first": "Bitte stimmen Sie den Geschäftsbedingungen zu",
  "Your email": "E-Mail",
  "Your email address has been successfully added to our list.": "Ihre E-Mail-Adresse wurde erfolgreich zu unserer Liste hinzugefügt."
};
export {
  n as Back,
  i as Close,
  r as Continue,
  o as Email,
  a as Hello,
  X as Optional,
  f as Register,
  p as Sending,
  S as Terms_default,
  w as Terms_default_label,
  e as and,
  t as days,
  s as days_abbr,
  z as default,
  l as hour,
  d as hours,
  u as hours_abbr,
  c as minutes,
  h as minutes_abbr,
  g as none,
  b as people,
  m as person,
  k as seconds,
  y as seconds_abbr
};
//# sourceMappingURL=de.CsetPALd.js.map
